import { nanoid } from 'nanoid';

export function newId(prefix?: string): string {
  return prefix ? `${prefix}_${nanoid(12)}` : nanoid();
}

export function brandSlug(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 48);
}
